<template>
  <!--合同地位-->
  <el-radio-group v-model="contractPostCode">
    <el-radio :label="item.dictCode" v-for="item in contractPostList" :key="index">{{item.dictName}}</el-radio>
  </el-radio-group>
  <!------------>
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-contractPost",
    data() {
      return {
        contractPostList: [],
        contractPostCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'CONTRACT_POST',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.contractPostList = res.data
        }
      })
    },
    watch: {
      contractPostCode: function (currentVal) {
        this.$emit('contractPostInfo', {contractPostCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
